import { render, staticRenderFns } from "./BDXMatchPendingManagerListPagination.vue?vue&type=template&id=b893a8f4"
import script from "./BDXMatchPendingManagerListPagination.vue?vue&type=script&lang=js"
export * from "./BDXMatchPendingManagerListPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports